import React from 'react'
import { Content, DefaultLayout } from '../../layouts'
import { Block, BlockGroup, Button, H4, H5 } from '@mote/ui'

export const SpringCUEScreen = () => {
  return (
    <DefaultLayout>
      <Content>
        <BlockGroup
          layout='horizontal'
          align='center'
          justify='space-evenly'
          margin='50px 0 50px 0'
          wrapped
        >
          <Block gap={15} maxWidth={500}>
            <H4 fontWeight={400}>
              Hello to all of our Spring CUE network!
              <span role='img' aria-label='hi'>
                👋
              </span>
            </H4>
            <p>
              By accessing this link, you’ve earned yourself 3 months of FREE
              access to our Unlimited tier, so you can:
            </p>
            <ul style={{ listStyle: 'disc' }}>
              <li>Get 90 seconds per voice note</li>
              <li>Transcribe your notes</li>
              <li>Translate for ELL students</li>
              <li>Store motes in your motebook</li>
              <li>Talk math and science with STEM mode</li>
            </ul>

            <H5>Ready to go? Click below, sign in and get moting!</H5>

            <Block maxWidth={200}>
              <Button tag='a' href='/r/r7a57z6' text="Let's go!" block />
            </Block>
          </Block>

          <Block maxWidth={400}>
            <img
              width='400'
              alt='Spring CUE'
              src='/images/illustrations/springCUE.png'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            />
          </Block>
        </BlockGroup>
      </Content>
    </DefaultLayout>
  )
}
